import request from '@/config/axios'
export const getRelationList = (bizType: string, bizId: number) =>
  request.get({ url: '/live/relation/list', params: { bizType, bizId } })
export const createRelation = (data: any) => request.post({ url: '/live/relation/create', data })
export const deleteRelation = (liveId: number, bizType: string, bizId: number) =>
  request.delete({ url: '/live/relation/delete', params: { liveId, bizType, bizId } })
